import { useState } from 'react'
import TaskAltIcon from '@mui/icons-material/TaskAlt'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
import { STANDARD_COLORS } from '../../utility/constants'
import { Popover, IconButton, Box, Tooltip } from '@mui/material'

const ApproveRejectSwitch = ({ index, switchState, handleSwitchChange, taskReference }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const options = ['Approve', 'N/A', 'Reject']
  const iconMap = {
    Approve: (
      <Tooltip title="Approve" placement="right">
        <TaskAltIcon sx={{ fontSize: 14, color: STANDARD_COLORS.REVIEW_SWITCH_TINT_ACCEPT }} />
      </Tooltip>
    ),
    Reject: (
      <Tooltip title="Reject" placement="right">
        <CancelOutlinedIcon
          sx={{ fontSize: 14, color: STANDARD_COLORS.REVIEW_SWITCH_TINT_REJECT }}
        />
      </Tooltip>
    ),
    'N/A': (
      <Tooltip title="No Action" placement="right">
        <span
          style={{
            fontSize: '10px',
            fontWeight: 'bold',
            color: 'rgb(94, 94, 94)',
            lineHeight: '10px',
          }}
        >
          N/A
        </span>
      </Tooltip>
    ),
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleOptionSelect = (value) => {
    handleSwitchChange(taskReference, value)
    handleClose()
  }

  const open = Boolean(anchorEl)
  const id = open ? `popover-${index}` : undefined
  const popoverOptions = options.filter((opt) => opt !== switchState)

  return (
    <div
      style={{
        minHeight: '28px',
        minWidth: '28px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'visible',
      }}
    >
      <span
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0,
          margin: 0,
          height: '24px',
          width: '24px',
        }}
      >
        <IconButton
          onClick={handleClick}
          sx={{
            width: '24px',
            height: '24px',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,
            background: '#E5E8F8',
            borderRadius: '6px',
            border: 'none',
          }}
        >
          {iconMap[switchState] ?? iconMap['N/A']}
        </IconButton>
      </span>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        PaperProps={{
          sx: {
            background: '#fff',
            borderRadius: 2,
            boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
            border: '1px solid #e0e0e0',
            minWidth: 20,
            position: 'fixed', // Use fixed to ensure popover does not affect table layout
            zIndex: 1300,
            pointerEvents: 'auto',
          },
        }}
        container={document.body}
        disableScrollLock
        disablePortal={false} // Let Popover use portal (default) for best isolation
        keepMounted // Keep the popover mounted to avoid reflow
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            padding: '8px',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {popoverOptions.map((option) => (
            <IconButton
              key={option}
              onClick={() => handleOptionSelect(option)}
              sx={{
                margin: '4px 0',
                color:
                  option === 'Approve'
                    ? STANDARD_COLORS.REVIEW_SWITCH_TINT_ACCEPT
                    : option === 'Reject'
                    ? STANDARD_COLORS.REVIEW_SWITCH_TINT_REJECT
                    : '#5e5e5e',
                width: '32px',
                height: '32px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 0,
                background: '#E5E8F8',
                borderRadius: '6px',
              }}
            >
              {iconMap[option]}
            </IconButton>
          ))}
        </Box>
      </Popover>
    </div>
  )
}

export default ApproveRejectSwitch
